import { Link, useLocation } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';
import { canAccessPortalPath } from '../../config/portalNavigation';

export default function PortalRouteAccessGuard({ path, children }) {
  const location = useLocation();
  const { user, authHelpers } = useAuth();
  const pathname = path || location.pathname;

  if (user?.role === 'platform_owner') {
    if (pathname === '/portal/careops-admin') return children;
    return null;
  }

  if (canAccessPortalPath(pathname, user, authHelpers())) {
    return children;
  }

  return (
    <div className="mx-auto flex min-h-[420px] max-w-xl items-center justify-center px-4 py-12">
      <div className="w-full rounded-xl border border-amber-200 bg-amber-50 p-6 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-white text-amber-700 shadow-sm">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <h1 className="font-heading text-xl font-semibold text-slate-900">This area is not available</h1>
        <p className="mt-2 text-sm leading-6 text-slate-700">
          Your current workplace role or subscription does not include this page.
        </p>
        <div className="mt-5 flex justify-center gap-3">
          <Button asChild className="bg-primary text-white hover:bg-primary-hover">
            <Link to="/portal/dashboard">Go to dashboard</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/portal/settings">Settings</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
